<template>
    <div>
        <el-form ref="unrulyGoodsForm" :model="unrulyGoodsForm" label-width="0px" style="margin-bottom: 5px;">
            <el-row>
                <el-col :span="8">
                    <el-form-item ref="keyword"  style="margin-bottom: 5px;">
                        <el-input v-model="unrulyGoodsForm.keyword" maxlength="20" placeholder="中文品名"></el-input>
                    </el-form-item>                     
                </el-col>
                <el-col :span="16">
                    <el-form-item ref="warning"  style="margin-bottom: 0px;">
                        <el-input v-model="unrulyGoodsForm.warning" maxlength="200" placeholder="描述"></el-input>
                    </el-form-item>                        
                </el-col>                                        
            </el-row>   
            <div style="display: flex; flex: row; justify-content: flex-end;">
                <el-button @click="btnSaveClick">确定</el-button>
                <el-button @click="btnCancelClick">取消</el-button>
                <el-button @click="btnRemoveClick">删除</el-button>
            </div>
        </el-form>
        <el-table ref="unrulyGoodsTable"
            :data="unrulyGoodsList" 
            highlight-current-row
            :show-header="false"
            empty-text="不合格品名"
            height="600"
            border
            :cell-class-name="tableCellClassName"
            @current-change="tableCurrentChanged"
            >
            <el-table-column
                prop="keyword"
                min-width="40%">
            </el-table-column>
            <el-table-column
                prop="warning"
                min-width="60%">  
            </el-table-column>            
        </el-table>
    </div>
</template>

<script>
    export default {
        mounted(){
            this.initUnrulyGoods()
        },          
        data() {
            return { 
                unrulyGoodsForm:{
                    index: -1
                },
                unrulyGoodsList:[]
            }
        },    
        methods:{
            async initUnrulyGoods(){        
                this.unrulyGoodsList = await this.$api.getUnrulyGoods()
            },
            tableCellClassName({row, column, rowIndex, columnIndex}){
                  //注意这里是解构
                  //利用单元格的 className 的回调方法，给行列索引赋值
                  row.index=rowIndex;
                  column.index=columnIndex;
            }, 
            tableCurrentChanged(val){
                this.unrulyGoodsForm = {...val}
            }, 
            async btnSaveClick(){
                console.log(this.unrulyGoodsForm)
                if(this.unrulyGoodsForm.keyword){
                    if(this.unrulyGoodsForm.index == -1){
                        let item = await this.$api.addUnrulyGoods(this.unrulyGoodsForm)
                        this.unrulyGoodsList.push({...item})
                    }else{
                        let item = await this.$api.updateUnrulyGoods(this.unrulyGoodsForm)                        
                        this.unrulyGoodsList[this.unrulyGoodsForm.index] = {...item}
                    }
                    this.$refs.unrulyGoodsTable.setCurrentRow();
                    this.unrulyGoodsForm = {index: -1}
                }
            },
            btnCancelClick(){
                this.$refs.unrulyGoodsTable.setCurrentRow();     
                this.unrulyGoodsForm = {index: -1}                           
            },
            async btnRemoveClick(){
                if(this.unrulyGoodsForm.index != -1){
                    await this.$api.removeUnrulyGoods(this.unrulyGoodsForm.id)
                    this.unrulyGoodsList.splice(this.unrulyGoodsForm.index, 1)
                }
                this.$refs.unrulyGoodsTable.setCurrentRow();                    
                this.unrulyGoodsForm = {index: -1}                
            },
        }        
    }
</script>

<style>
</style>
